// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"e3f91975","325":"e3f91975","411":"e3f91975","699":"e3f91975","715":"e3f91975"}[chunkId] + ".chunk.css";
};